import { render } from "./PersonalProjects.vue?vue&type=template&id=2224253c&scoped=true"
import script from "./PersonalProjects.vue?vue&type=script&lang=js"
export * from "./PersonalProjects.vue?vue&type=script&lang=js"

import "./PersonalProjects.vue?vue&type=style&index=0&id=2224253c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2224253c"]])

export default __exports__